<template>
  <div class="shoppingcart">
    <div class="btn_box_private">
      <el-button @click="oepnDialogVisible('reserve')" class="btn_private">{{
        $t("MySpace.batchReserve")
      }}</el-button>

      <el-popconfirm
        @onConfirm="batchBtn('delete')"
        :title="$t('MySpace.tip.deleteSelectFile')"
        :cancel-button-text="$t('MySpace.tip.cancel')"
        :confirm-button-text="$t('MySpace.tip.confirm')"
      >
        <el-button class="btn_private" slot="reference">
          {{ $t("MySpace.batchDelete") }}</el-button
        >
      </el-popconfirm>
    </div>
    <div class="table_b">
      <el-table
        :data="shopingCartData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="35"></el-table-column>
        <el-table-column
          prop="productName"
          :label="$t('MySpace.dataSatName')"
        ></el-table-column>
        <el-table-column
          prop="dataId"
          :label="$t('MySpace.dataID')"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('MySpace.createTime')"
        ></el-table-column>
        <!-- <el-table-column prop="status" label="状态"> </el-table-column> -->
        <el-table-column fixed="right" :label="$t('MySpace.Operation')">
          <template slot-scope="scope">
            <div class="btn_box_private">
              <el-popconfirm
                @onConfirm="handleClick(scope.row, 'download')"
                :title="$t('MySpace.tip.downloadTheFile')"
                :cancel-button-text="$t('MySpace.tip.cancel')"
                :confirm-button-text="$t('MySpace.tip.confirm')"
              >
                <el-button class="btn_private" slot="reference">
                  {{ $t("MySpace.tip.download") }}</el-button
                >
              </el-popconfirm>
              <!-- <el-button
                @click="handleClick(scope.row, 'delete')"
                type="text"
                size="small"
                class="btn_private"
                >{{ $t("MySpace.delete") }}</el-button
              > -->

              <el-popconfirm
                @onConfirm="handleClick(scope.row, 'delete')"
                :title="$t('MySpace.tip.deleteTheFile')"
                :cancel-button-text="$t('MySpace.tip.cancel')"
                :confirm-button-text="$t('MySpace.tip.confirm')"
              >
                <el-button class="btn_private" slot="reference">
                  {{ $t("MySpace.delete") }}</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer_page" v-log="{ params: { clickName: '下载数据' } }">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      class="dialog_box"
      :title="$t('MySpace.tip.dataReservation')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="input_box">
        <span>{{ $t("MySpace.tip.projectName") }}</span>
        <input type="text" v-model="taskName" />
      </div>
      <div class="input_box">
        <span>{{ $t("MySpace.tip.applicationNotes") }}</span>
        <textarea
          name=""
          id=""
          cols="30"
          rows="10"
          v-model="appNote"
        ></textarea>
        <!-- <input type="text" /> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("MySpace.tip.cancel")
        }}</el-button>
        <el-button type="primary" @click="batchBtn('reserve')">{{
          $t("MySpace.tip.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  shoppingCart,
  addOrder,
  daleteBatchShoppingCart,
} from "@/axios/private.js";
import bus from "@/bus";
export default {
  data() {
    return {
      taskName: "",
      appNote: "",
      input: "",
      pageSize: 10,
      currentPage: 1,
      total: null,
      shopingCartData: [],
      collectionData: [],
      dialogVisible: false,
    };
  },
  methods: {
    // 校验是否登录
    verifyLogin() {
      return localStorage.getItem("token") && localStorage.getItem("loginName");
    },
    async addOrderFun(param) {
      return await addOrder(param);
    },
    async daleteBatchShoppingCartrFun(param) {
      return await daleteBatchShoppingCart(param);
    },
    batchBtn(type) {
      var userVerifyLogin = this.verifyLogin();

      if (!userVerifyLogin) {
        // 提示用户登录
        bus.$emit("LoginDialogEmit");
        return;
      }
      console.log(this.collectionData, userVerifyLogin);
      if (this.collectionData.length == 0) {
        this.$message({message:this.$t("MySpace.tip.seleteDataEntry"),duration:1000});
        return;
      }
   
      // 批量预定
      var idsStr, dataIdStr;
      var dataIdsArr = [];
      var idArr = [];
      var productCodes = [];
      this.collectionData.forEach((item) => {
        dataIdsArr.push(item.dataId);
        idArr.push(item.id);
        if (productCodes.indexOf(item.productCode) == -1) {
          productCodes.push(item.productCode);
        }
      });
      idsStr = idArr.join(",");
      dataIdStr = dataIdsArr.join(",");
      var param = {
        scIds: idsStr,
        dataIds: dataIdStr,
        // productName: this.collectionData[0].productName,
        productCodes: productCodes.join(),
        taskName: this.taskName,
        appNote: this.appNote,
      };

      if (type == "reserve") {
           if (this.taskName == "" || this.appNote == "") {
        this.$message({message:this.$t("MySpace.tip.PleaseFill"),duration:1000});
        return;
      }
        // this.dialogVisible = true;
        //   批量预定
        this.addOrderFun(param).then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.getShoppingCartList();
            this.dialogVisible = false;
            this.$message({
              message: this.$t("MySpace.tip.reservationSuccess"),
              type: "success",
              duration:1000
            });
            bus.$emit("updateOrder");
          } else {
            alert(res.data.msg);
          }
        });
      } else {
        var ids = [];
        this.collectionData.forEach((item) => {
          ids.push(item.id);
        });
        var idsStr = ids.join(",");
        //   批量删除
        this.daleteBatchShoppingCartrFun(idsStr).then((res) => {
          if (res.data.code == 200) {
            // alert("删除成功");
            this.getShoppingCartList();
          } else {
            alert(res.data.msg);
          }
        });
      }
    },
    oepnDialogVisible() {
      var userVerifyLogin = this.verifyLogin();

      if (!userVerifyLogin) {
        // 提示用户登录
        bus.$emit("LoginDialogEmit");
        return;
      }
      if (this.collectionData.length == 0) {
        this.$message({message:this.$t("MySpace.tip.seleteDataEntry"),duration:1000});
        return;
      }
      this.dialogVisible = true;
    },
    handleClick(tab, type) {
      console.log(tab, type);
      if (type == "download") {
          // return
          //  console.log(obj, this.DataTable);
      var token = localStorage.getItem("token");
      if (!token) {
        bus.$emit("LoginDialogEmit");
        return
      }

      const a = document.createElement("a"); // 创建a标签
      a.setAttribute("download", ""); // download属性
      a.setAttribute(
        "href",
        // ${this.GLOBAL.url}
        `${this.GLOBAL.url}sdg-api/share/data/download?dataId=${tab.dataId}&productCode=${tab.productCode}&lang=${this.language=='zh'?'zh_CN':'en_US'}&token=${token}`
      ); // href链接
      // productCode=${scope.row.product_code}
      a.click(); // 自执行点击事件
        // 预定
        // var param = {
        //   scIds: tab.id,
        //   dataIds: tab.dataId,
        //   productCodes: tab.productCode,
        // };
        // this.addOrderFun(param).then((res) => {
        //   if (res.data.code == 200) {
        //     this.getShoppingCartList();
        //   } else {
        //     alert(res.data.msg);
        //   }
        // });
      } else {
        // 删除
        this.daleteBatchShoppingCartrFun(tab.id).then((res) => {
          this.getShoppingCartList();
        });
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getShoppingCartList();
    },
    async getShoppingCartList() {
      var param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      var res = await shoppingCart(param);
      this.shopingCartData = res.data.data.records;
      this.total = res.data.data.total;
    },
    handleSelectionChange(obj) {
      this.collectionData = obj;
    },
  },
  mounted() {
    this.getShoppingCartList();
  },
};
</script>

<style lang="scss">
.dialog_box {
  .input_box {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 10px;
    span {
      width: 86px;
      white-space: nowrap;
      text-align: right;
      margin-right: 10px;
    }
    input {
      flex: 1;
      height: 32px;
      border: 1px solid #ccc;
      text-indent: 16px;
      color: #666;
    }
    textarea {
      text-indent: 4px;
      color: #666;
      font-size: 16px;
      flex: 1;
      border: 1px solid #ccc;
      resize: "vertical";

      outline: none;
    }
  }
}
.shoppingcart {
  margin-bottom: 10px;
  th {
    background: #e9f7fe;
  }
  .table_b {
    margin-top: 20px;
  }
  .btn_box_private {
    display: flex;
    width: fit-content;
    margin: 10px 0;
  }
  .btn_private {
    padding: 4px 20px;
    margin-right: 4px;
    border: 1px solid #0a97d9;
    border-radius: 20px;
    color: #0a97d9;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      background: #0a97d9;
      color: #fff;
    }
  }
  .footer_page {
    text-align: center;
    margin: 20px auto;
  }
}
</style>